
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-staging/phoenix",
      function () {
        return require("private-next-pages/home-staging/phoenix/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-staging/phoenix"])
      });
    }
  